import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';
import FilledArrowDownIcon from '@/common/assets/icons/filledArrowDown.svg?react';
import { css } from 'styled-system/css';

const FilledArrowDown = createAttachment({
  element: <FilledArrowDownIcon />,
  size: 'small',
  height: css({ height: '32px' }),
});

export default FilledArrowDown;
